'use client';

import { useEffect, useLayoutEffect } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

interface UsePreventBodyScrollProps {
  open: boolean;
}

export const usePreventBodyScroll = ({ open }: UsePreventBodyScrollProps) => {
  useIsomorphicLayoutEffect(() => {
    if (!open) {
      return;
    }

    const { body } = document;
    const { scrollY } = window;
    const originalBodyStyle = body.style.cssText;

    // 스크롤 위치 저장을 위한 CSS 변수 설정
    document.documentElement.style.setProperty('--scroll-y', `${scrollY}px`);

    // overflow: hidden만으로 스크롤 차단 (position: fixed 사용 안함)
    body.style.cssText = `
      ${originalBodyStyle}
      overflow: hidden !important;
      -webkit-overflow-scrolling: none !important;
      touch-action: none !important;
      overscroll-behavior: none !important;
    `;

    // data attribute 추가
    body.setAttribute('data-scroll-locked', 'true');

    return () => {
      // 원래 스타일 복원
      body.style.cssText = originalBodyStyle;
      body.removeAttribute('data-scroll-locked');

      // CSS 변수 제거
      document.documentElement.style.removeProperty('--scroll-y');

      // 스크롤 위치 복원
      window.scrollTo(0, scrollY);
    };
  }, [open]);
};
